import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.navItems = [];
        this.contents = [];
        this.onScrollBound = () => { };
        this.navbarSteps = null;
    }
    connect() {
        // Get all nav items with the data-scrollspy-active attribute
        this.navItems = Array.from(document.querySelectorAll("[data-scrollspy-active]"));
        // Get all step content blocks inside the container target
        this.contents = Array.from(this.containerTarget.querySelectorAll("[id^='scrollspy-step-']"));
        this.navbarSteps = document.querySelector("#navbar-steps .d-flex");
        // Remove d-none from the first element by default
        if (this.navItems.length > 0) {
            this.navItems[0].classList.remove("d-none");
        }
        this.onScrollBound = this.onScroll.bind(this);
        window.addEventListener("scroll", this.onScrollBound);
        this.onScroll();
    }
    disconnect() {
        window.removeEventListener("scroll", this.onScrollBound);
    }
    onScroll() {
        const scrollTop = window.scrollY + 100; // Offset
        let currentIndex = null;
        // Find the last content block that has passed the scroll position
        this.contents.forEach((content, index) => {
            if (content.offsetTop <= scrollTop) {
                currentIndex = index;
            }
        });
        if (currentIndex !== null) {
            this.navItems.forEach((navElem, index) => {
                if (index === currentIndex) {
                    navElem.classList.remove("d-none");
                }
                else {
                    navElem.classList.add("d-none");
                }
            });
        }
        // Navbar top detection
        /*
        if (this.navbarSteps) {
          const rect = this.navbarSteps.getBoundingClientRect();
          if (rect.top <= 0) {
            this.navbarSteps.classList.remove("px-2");
            this.navbarSteps.classList.add("px-0");
          } else {
            this.navbarSteps.classList.remove("px-0");
            this.navbarSteps.classList.add("px-2");
          }
        }
        */
    }
}
default_1.targets = ["container"];
export default default_1;
